const Button = () => {
    return (
        <>
            <button className="button">Button</button>
            <button className="disabled">Disabled</button>
            <button className="success">Success</button>
            <button className="delete">Delete</button>
        </>
    );
};

export default Button;
